import type { MentoringDiscount } from '@algoacademy/backend/modules/payment/discount-pricing'
import { formatBillingPeriodCount, type MentoringDiscountSummarySource } from './mentoring-terms'

/** How much of the discount the student still has ahead, said in billing periods. */
export function describeDiscountInForce(
  discount: MentoringDiscountSummarySource,
  billingCadenceLabel?: string
): string {
  if (discount.periodCount === null) {
    return 'Uczeń ma zniżkę bez końca. To, co ustawisz niżej, zastąpi ją w całości.'
  }

  const remainingPeriods = discount.remainingPeriods ?? discount.periodCount

  if (remainingPeriods <= 0) {
    return 'Zniżka ucznia już się skończyła. Wpisz niżej, przez ile okresów ma działać od nowa.'
  }

  const cadenceHint = billingCadenceLabel ? ` (${billingCadenceLabel.toLocaleLowerCase('pl')})` : ''

  return `Uczniowi została zniżka na ${formatBillingPeriodCount(remainingPeriods)}${cadenceHint}. Wpisz niżej, przez ile okresów ma działać od teraz.`
}

/**
 * The same discount means the same three figures the API stores - shape, value
 * and length. The reason is a note for staff and never changes what the buyer
 * pays, so it does not make two discounts different.
 */
export function isSameDiscount(
  left: MentoringDiscount | null,
  right: MentoringDiscount | null
): boolean {
  if (left === null || right === null) {
    return left === right
  }

  return (
    left.shape === right.shape &&
    left.value === right.value &&
    left.periodCount === right.periodCount
  )
}
